export default "__VITE_ASSET__0M5U6E8U__"